<template>
  <div id="app" :style="{ width: $w + 100 + 'px' }">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  computed: {},
  beforeCreate() {
    let w = this.$w + 100 + "px";
    document.querySelector("html").setAttribute("style", "width:" + w);
    document.querySelector("body").setAttribute("style", "width:" + w);
  },
};
</script>

<style lang="scss">
@import "assets/scss/flex.css";
@import "assets/scss/common.scss";

body,
html,
#app {
  width: 100%;
  border: 0 !important;
  background: #1b1f2a;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.red {
  color: #ed4014;
}
.red {
  color: gray;
}
.page-intro-box {
  padding: 10px 20px;
  background: #f9f9f9;
  margin-bottom: 20px;
}
.text-gray {
  color: gray;
}
.content-main {
  // width: 940px;
  margin: 0 auto;
}
.ivu-page-next,
.ivu-page-prev {
  background: none !important;
  border: 1px solid #e1c798;
}
.ivu-page-item {
  background-color: #333 !important;
  border: 1px solid #e1c798;
  color: #e1c798;
  a {
    color: #e1c798;
  }
}
.ivu-page-item-active {
  background: #999 !important;
}
.pages {
  li {
    &:hover {
      border: 1px solid #ff9900;
      a {
        color: #ff9900;
      }
    }
  }
  .ivu-page-options-elevator {
    color: #aaa;
  }
  .ivu-page-options-elevator input {
    background: none;
    border: 1px solid #e1c798;
    color: #e1c798;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue